import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import FormRow from "../ui/uiElements/FromRow.component";
import { Link } from "react-router-dom";
import AuthCard from "../ui/uiElements/AuthCard.component";
import { useRegister } from "../hooks/useRegister";

function Register() {
  const { register: formRegister, formState, handleSubmit, getValues } = useForm();
  const { errors } = formState;

  const { register, isLoading } = useRegister();

  const handleRegister = ({ username, email, password }) => {
    register({
      username,
      email,
      password,
    });
  };

  return (
    <AuthCard title="CREATE AN ACCOUNT">
      <Form onSubmit={handleSubmit(handleRegister)}>
        <FormRow label="UserName" error={errors?.username?.message}>
          <Form.Control
            className=" rounded border border-secondary border-opacity-50 "
            type="text"
            id="username"
            placeholder="Enter UserName"
            disabled={isLoading}
            {...formRegister("username", {
              required: "This field is required",
            })}
          />
        </FormRow>
        <FormRow label="Email" error={errors?.email?.message}>
          <Form.Control
            className=" bg-light rounded border border-secondary border-opacity-50 "
            type="email"
            id="email"
            placeholder="Enter Email"
            disabled={isLoading}
            {...formRegister("email", {
              required: "This field is required",
              pattern: {
                value: /\S+@\S+\.\S+/,
                message: "Please provide a valid email address",
              },
            })}
          />
        </FormRow>
        <FormRow label="Password" error={errors?.password?.message}>
          <Form.Control
            className=" bg-light rounded border border-secondary border-opacity-50 "
            type="password"
            id="password"
            placeholder="Enter Password"
            disabled={isLoading}
            {...formRegister("password", {
              required: "This field is required",
              minLength: {
                value: 6,
                message: "Password needs a minimum of 6 characters",
              },
            })}
          />
        </FormRow>
        <FormRow label="Confirm Password" error={errors?.repeatPassword?.message}>
          <Form.Control
            className=" bg-light rounded border border-secondary border-opacity-50 "
            type="password"
            id="repeatPassword"
            placeholder="Confirm Password"
            disabled={isLoading}
            {...formRegister("repeatPassword", {
              required: "This field is   required",
              validate: (value) => value === getValues().password || "Passwords need to match",
            })}
          />
        </FormRow>
        <div className="d-flex justify-content-center">
          <button className="w-100  btn btn-success mt-3 btn-lg text-white" type="submit" disabled={isLoading}>
            Signup
          </button>
        </div>
        <p className="text-center text-muted mt-5 mb-0">
          Already have an account?
          <Link to="/login" className="fw-bold text-body">
            <u>Login here</u>
          </Link>
        </p>
      </Form>
    </AuthCard>
  );
}

export default Register;
